export default "__VITE_ASSET__iqrAZKWK__"